import React from 'react';
import classnames from 'classnames';
import styles from './PublishedBar.css';

export interface PublishedBarProps {
  /** Boolean Flag to Add published styles */
  published?: boolean;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Renders a vertical Bar, with or without color based on prop
 *
 * @param {PublishedBarProps} param
 *
 * @returns JSX.Element
 */
export const PublishedBar = ({
  published = false,
  'data-testid': dataTestId = 'publish-bar'
}: PublishedBarProps) => (
  <hr
    className={classnames(styles.publishedBar, published && styles.published)}
    data-testid={dataTestId}
  />
);

export default PublishedBar;
